import React, { useEffect ,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation, Link} from "react-router-dom";
import BlckMembInqApi from 'Apis/BlckMembInqApi';
import MgpStore from 'Stores/Store';
import 'Assets/css/BlckMemb.css';
import { Helmet } from 'react-helmet-async';

const AppBlckMembUi = () => {
    const location = useLocation(); 
    const [blckMembState, setBlckMembState] = useState<any>();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    useEffect(()=>{
        BlckMembInqApi(location.state?.loginId).then((resp)=>{
            setBlckMembState(resp.apiBody);
        });
    },[MgpStore.getState().LangSetState.Lang]);
    return(
        <>
        <Helmet>
            <title>BE@RBRICK CONNECT - Blocked Member</title>
        </Helmet>
        <div className='loginInputWrap'>
            <div className='membFindTitl'>
                <h1>{langData&&langData.LOGIN_MEMB_BLCK_MAIN_TITL_00}</h1>
                <div className='blckMembIcon'>
                    <img src={process.env.PUBLIC_URL+"/images/common/blckMembIcon3.png"} alt="블럭회원 아이콘" />
                </div>
            </div>
            <div className='blckNoticeWrap'>
                <p className='blckKindNm'>{blckMembState&&blckMembState.blckMsgDesc}</p>
                {blckMembState&&blckMembState.prmnYn == "N" ?
                    <p className='dateP'>{blckMembState&&blckMembState.blckStrtDtime} ~ {blckMembState&&blckMembState.unblckDtime}</p>
                    :
                    <></>
                }
            </div>
            <Link to='/' replace className='homeBtn defaultBtn'>
                <p>{langData&&langData.GLB_HOME_BTN_00}</p>
            </Link>

        </div>
        </>
    )
}

export default AppBlckMembUi;